import { render, staticRenderFns } from "./MarkeVozila.vue?vue&type=template&id=56e125d8&scoped=true&"
import script from "./MarkeVozila.vue?vue&type=script&lang=ts&"
export * from "./MarkeVozila.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e125d8",
  null
  
)

export default component.exports